"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var vizportal_webclient_api_1 = require("@tableau/vizportal-webclient-api");
var GetDatasourcesWithConnectabilityDetailsMethod_1 = require("@tableau/vizportal-webclient-api/lib/api/methods/GetDatasourcesWithConnectabilityDetailsMethod");
var IFilterClause_1 = require("@tableau/vizportal-webclient-api/lib/api/types/IFilterClause");
var React = require("react");
var reselect_1 = require("reselect");
var shallowEqual = require("shallowequal");
var Localize_1 = require("../../../gen-src/Localize");
var globalTypes_1 = require("../../../gen-src/queries/globalTypes");
var PaginatedRowStore_1 = require("../../../src/components/datagrid/PaginatedRowStore");
var ConnectToDialogFunctions_1 = require("../ConnectToDialogFunctions");
var ConnectToErrorHandling_1 = require("../ConnectToErrorHandling");
var ConnectToDatasourcesDisplayGrid_1 = require("../DisplayGrids/ConnectToDatasourcesDisplayGrid");
var ConnectToDatasourcesQueryGrid = /** @class */ (function (_super) {
    __extends(ConnectToDatasourcesQueryGrid, _super);
    function ConnectToDatasourcesQueryGrid() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ConnectToDatasourcesQueryGrid.prototype.render = function () {
        var _this = this;
        return (React.createElement(ConnectToDatasourcesQueryWrapper, { orderBy: this.props.orderBy, searchText: this.props.searchText, updateRowsCallback: this.props.updateRowsCallback, vizPortalClient: this.props.vizPortalWebClientRequester }, function (_a) {
            var rowCount = _a.rowCount, rowStore = _a.rowStore;
            return (React.createElement(ConnectToDatasourcesDisplayGrid_1.ConnectToDatasourcesDisplayGrid, { hasFilter: _this.props.searchText !== '', orderBy: _this.props.orderBy, rowCount: rowCount, rowStore: rowStore, selectedKeys: _this.props.selectedKeys, updateSelectionForKey: _this.props.updateSelectionForKey, updateSortOrder: _this.props.updateSortOrder }));
        }));
    };
    return ConnectToDatasourcesQueryGrid;
}(React.PureComponent));
exports.ConnectToDatasourcesQueryGrid = ConnectToDatasourcesQueryGrid;
function keyBy(collection, iteratee) {
    if (collection === undefined) {
        return {};
    }
    return collection.reduce(function (result, value) {
        result[iteratee(value)] = value;
        return result;
    }, {});
}
function makeRowsForItems(result) {
    if (result.datasources === undefined) {
        return [];
    }
    var projectsMap = keyBy(result.projects, function (project) { return project.id; });
    var usersMap = keyBy(result.users, function (user) { return user.id; });
    return result.datasources.map(function (item) {
        var hasCertifier = item.certificationDetails != null && item.certificationDetails.certifier != null;
        var certifier = hasCertifier ? item.certificationDetails.certifier : undefined;
        var hasdataQualityIndicator = item.dataQualityIndicators && item.dataQualityIndicators.length > 0;
        var owner = usersMap && item.ownerId ? usersMap[item.ownerId] : undefined;
        var project = projectsMap && item.projectId ? projectsMap[item.projectId] : undefined;
        return {
            data: {
                id: item.repositoryUrl,
                connectionDetails: item.connectionDetails,
                extractLastUpdateTime: item.lastRefreshedAt || null,
                hasExtracts: item.hasExtracts,
                isCertified: item.certificationDetails != null && item.certificationDetails.isCertified,
                isSupported: ConnectToDialogFunctions_1.isRowEnabledForDatasource(item),
                certificationNote: item.certificationDetails != null ? item.certificationDetails.certificationNote : '',
                certifierName: hasCertifier && certifier !== undefined ? certifier.displayName : '',
                certifierUsername: hasCertifier && certifier !== undefined ? certifier.username : '',
                certifierDomain: hasCertifier && certifier !== undefined ? certifier.domainName : '',
                dataQualityIndicator: hasdataQualityIndicator ? item.dataQualityIndicators[0] : null,
                name: item.name || '',
                owner: owner !== undefined ? owner.displayName : Localize_1.Messages.HiddenUser(),
                project: project !== undefined && project.name ? project.name : '',
                workbookConnectionCount: item.connectedWorkbooksCount,
            },
            key: item.repositoryUrl,
        };
    });
}
var ConnectToDatasourcesQueryWrapper = /** @class */ (function (_super) {
    __extends(ConnectToDatasourcesQueryWrapper, _super);
    function ConnectToDatasourcesQueryWrapper(props) {
        var _this = _super.call(this, props) || this;
        // tslint:disable-next-line:typedef
        _this.memoizedCreateRowStore = reselect_1.defaultMemoize(createRowStore, function (a, b) { return shallowEqual(a, b); });
        _this.state = { count: 1, fatalError: false };
        return _this;
    }
    ConnectToDatasourcesQueryWrapper.prototype.render = function () {
        var rowStore = this.memoizedCreateRowStore(this.props.orderBy, this.props.searchText, this.props.vizPortalClient);
        return (React.createElement(React.Fragment, null,
            this.props.children({ rowCount: this.state.count, rowStore: rowStore }),
            this.state.fatalError && ConnectToErrorHandling_1.reportConnectToWebClientErrors(['INTERNAL_SERVER_ERROR'])));
    };
    ConnectToDatasourcesQueryWrapper.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.searchText !== this.props.searchText
            || prevProps.orderBy.field !== this.props.orderBy.field
            || prevProps.orderBy.direction !== this.props.orderBy.direction) {
            this.updateCount();
        }
    };
    ConnectToDatasourcesQueryWrapper.prototype.componentDidMount = function () {
        this.updateCount();
    };
    ConnectToDatasourcesQueryWrapper.prototype.updateCount = function () {
        var _this = this;
        var getDatasources = this.props.vizPortalClient.createSender(GetDatasourcesWithConnectabilityDetailsMethod_1.GetDatasourcesWithConnectabilityDetailsMethod);
        var filter = {
            clauses: [vizportal_webclient_api_1.Filter.search(this.props.searchText), vizportal_webclient_api_1.Filter.fieldEq(IFilterClause_1.FilterFieldNames.isPublished, true)],
            operator: IFilterClause_1.FilterOps.and
        };
        getDatasources(new vizportal_webclient_api_1.GetItemsParams(undefined, filter)).then(function (slice) {
            if (vizportal_webclient_api_1.WebClientResponseHelper.isErrorResponse(slice) || !ConnectToDialogFunctions_1.isIGetDatasourcesResult(slice.response.result)) {
                _this.setState({ count: 0, fatalError: true });
            }
            else {
                var count = slice.response.result.totalCount || 0;
                _this.setState({ count: count, fatalError: false });
                _this.props.updateRowsCallback(count);
            }
        }, function () { return _this.setState({ count: 0, fatalError: true }); });
    };
    return ConnectToDatasourcesQueryWrapper;
}(React.PureComponent));
function createRowStore(orderBy, searchText, client) {
    return new PaginatedRowStore_1.PaginatedRowStore(createRowFetcher(orderBy, searchText, client));
}
function createRowFetcher(orderBy, searchText, client) {
    var getDatasources = client.createSender(GetDatasourcesWithConnectabilityDetailsMethod_1.GetDatasourcesWithConnectabilityDetailsMethod);
    return function queryRows(pageBoundaries) {
        return __awaiter(this, void 0, void 0, function () {
            var page, filter, order, slice;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        page = {
                            startIndex: pageBoundaries.start,
                            maxItems: pageBoundaries.end - pageBoundaries.start + 1
                        };
                        filter = {
                            clauses: [vizportal_webclient_api_1.Filter.search(searchText), vizportal_webclient_api_1.Filter.fieldEq(IFilterClause_1.FilterFieldNames.isPublished, true)],
                            operator: IFilterClause_1.FilterOps.and
                        };
                        order = [{
                                field: orderBy.field,
                                ascending: orderBy.direction === globalTypes_1.OrderDirection.ASC,
                            }];
                        return [4 /*yield*/, getDatasources(new vizportal_webclient_api_1.GetItemsParams(page, filter, order))];
                    case 1:
                        slice = _a.sent();
                        if (!vizportal_webclient_api_1.WebClientResponseHelper.isErrorResponse(slice) && ConnectToDialogFunctions_1.isIGetDatasourcesResult(slice.response.result)) {
                            return [2 /*return*/, {
                                    totalCount: slice.response.result.totalCount || 0,
                                    rows: makeRowsForItems(slice.response.result)
                                }];
                        }
                        else {
                            return [2 /*return*/, {
                                    totalCount: 0,
                                    rows: [],
                                    errors: ['INTERNAL_SERVER_ERROR'],
                                }];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
}
//# sourceMappingURL=ConnectToDatasourcesQueryGrid.js.map